<template>
  <div id="table-instances" class="table-instances-container">

    <template lang="html">
      <div>
        <vs-table
          noDataText="Nenhum usuário disponível para vincular" 
          v-model="selectedUser"
          :data="erpUsers"
          search
          pagination
          >
          <template slot="header">
            <h3 class="ml-4 pb-2">
              Usuários da ERP {{ this.selected.corporate_name }}
            </h3>
          </template>
          <template slot="thead">
            <vs-th sort-key="nome">
              NOME
            </vs-th>
          </template>
    
          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td :data="data[indextr].nome">
                {{data[indextr].nome}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </template>

    <vs-button 
      class="float-left"
      :disabled="!selectedUser"
      @click="createErpUser" 
    >
      Selecionar Usuário
    </vs-button>
  </div>
  </template>
  
  <script>

  import ErpUser from '@/http/requests/erpUser'
  
    export default {
      name: 'UserModal',
      data() {
        return {
          itemsPerPage: 4,
          selectedUser: null,
          isMounted: false,
          erpUsers: [],
          erpId: null,
        }
      },
      props: {
        selected: {
          type: Object,
          required: true
        }
      },
      methods: {
        async loadingData() {
          this.erpId = this.selected.id === undefined ? 0 : this.selected.id;

          await ErpUser.fetch(this.erpId)
          .then(response => {
            this.erpUsers = response.data.data.paginatedErpUser.items;            
          })
          .catch(error => {
            console.log(error);
          });
        },
        createErpUser() {
          let userIntegrationId = parseInt(this.selectedUser.codigo)
          let dataToCreate = {
            erp_id: this.erpId,
            user_integration_id: userIntegrationId,
            erp_name: this.selected.corporate_name,
            user_integration_name: this.selectedUser.nome
          }
          this.selectedUser = null,
          this.$emit('erpUserData', dataToCreate)
        }
      },
      watch: {
        selected: async function(newVal) {
          this.erpId = newVal.id
          await this.loadingData();
        }
      },
      async mounted() {
        await this.loadingData();
        this.isMounted = true
      },
    }
  </script>
  
  <style lang="scss">
    #table-instances {
      width: 100%;
  
      .vs-con-table {
  
        .product-name {
          max-width: 23rem;
        }
  
        .vs-table--header {
          display: flex;
          flex-wrap: wrap-reverse;
          margin-left: 1.5rem;
          margin-right: 1.5rem;
          > span {
            display: flex;
            flex-grow: 1;
          }
  
          .vs-table--search{
            padding-top: 0;
  
            .vs-table--search-input {
              padding: 0.9rem 2.5rem;
              font-size: 1rem;
  
              &+i {
                left: 1rem;
              }
  
              &:focus+i {
                left: 1rem;
              }
            }
          }
        }
  
        .vs-table {
          border-collapse: separate;
          border-spacing: 0 1.3rem;
          padding: 0 1rem;
  
  
          tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 10px;
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
              &.img-container {
                // width: 1rem;
                // background: #fff;
  
                span {
                  display: flex;
                  justify-content: flex-start;
                }
  
                .product-img {
                  height: 110px;
                }
              }
            }
            td.td-check{
              padding: 20px !important;
            }
          }
        }
  
        .vs-table--thead{
          th {
            padding-top: 0;
            padding-bottom: 0;
  
            .vs-table-text{
              text-transform: uppercase;
              font-weight: 600;
            }
          }
          th.td-check{
            padding: 0 15px !important;
          }
          tr{
            background: none;
            box-shadow: none;
          }
        }
  
        .vs-table--pagination {
          justify-content: center;
        }
      }
    }
    .vs-pagination--li span {
      font-size: 14px;
    }
  </style>
  